var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcUploadWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02952 1.52815C8.28977 1.26837 8.71122 1.26837 8.97147 1.52815L12.0191 4.57027C12.2797 4.83038 12.2801 5.25249 12.0199 5.51308C11.7598 5.77366 11.3377 5.77404 11.0771 5.51393L9.16716 3.6074L9.16716 9.96165C9.16716 10.3298 8.86868 10.6283 8.50049 10.6283C8.13231 10.6283 7.83383 10.3298 7.83383 9.96165L7.83383 3.6074L5.92386 5.51393C5.66327 5.77404 5.24116 5.77366 4.98105 5.51308C4.72093 5.25249 4.72131 4.83038 4.9819 4.57027L8.02952 1.52815ZM3.16667 9.46956C3.53486 9.46956 3.83333 9.76804 3.83333 10.1362V12.595C3.83333 12.8017 3.9116 12.9934 4.04077 13.1296C4.16881 13.2645 4.33479 13.3333 4.5 13.3333H12.5C12.6652 13.3333 12.8312 13.2645 12.9592 13.1296C13.0884 12.9934 13.1667 12.8017 13.1667 12.595V10.1362C13.1667 9.76804 13.4651 9.46956 13.8333 9.46956C14.2015 9.46956 14.5 9.76804 14.5 10.1362V12.595C14.5 13.1335 14.2973 13.6565 13.9264 14.0474C13.5543 14.4394 13.042 14.6666 12.5 14.6666H4.5C3.95797 14.6666 3.44567 14.4394 3.07361 14.0474C2.70268 13.6565 2.5 13.1335 2.5 12.595V10.1362C2.5 9.76804 2.79848 9.46956 3.16667 9.46956Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUploadWhite);
export default __webpack_public_path__ + "static/media/ic-upload-white.f600976f8b9f5c186884540dc7ed6882.svg";
export { ForwardRef as ReactComponent };